module.exports = __webpack_public_path__ + "static/awards-7e4e8a3eac1fd3b65b9b5c2866ba4d69.png";